import React from 'react';
import { Link } from 'react-router-dom';

const ReplayCallToAction = () => {
    // Define app-specific auth paths (adjust if your routes are different)
    const signupPath = '/signup';

    return (
        <div className="w-full">
            <div className="relative bg-gradient-to-br from-indigo-700 to-indigo-900 text-white rounded-lg shadow-lg overflow-hidden">
                {/* Background pattern overlay */}
                <div className="absolute inset-0 opacity-10" 
                     style={{
                        backgroundImage: "url('data:image/svg+xml,%3Csvg width=\'52\' height=\'26\' viewBox=\'0 0 52 26\' xmlns=\'http://www.w3.org/2000/svg\'%3E%3Cg fill=\'none\' fill-rule=\'evenodd\'%3E%3Cg fill=\'%23ffffff\' fill-opacity=\'0.4\'%3E%3Cpath d=\'M10 10c0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6h2c0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4 3.314 0 6 2.686 6 6 0 2.21 1.79 4 4 4v2c-3.314 0-6-2.686-6-6 0-2.21-1.79-4-4-4-3.314 0-6-2.686-6-6zm25.464-1.95l8.486 8.486-1.414 1.414-8.486-8.486 1.414-1.414z\' /%3E%3C/g%3E%3C/g%3E%3C/svg%3E')",
                        pointerEvents: "none" // Make transparent to clicks
                     }}>
                </div>
                
                {/* Content wrapper - reduced padding */}
                <div className="relative p-4 flex flex-col justify-center">
                    {/* Text content - reduced margins */}
                    <div className="mb-4">
                        <h2 className="text-xl font-bold mb-2">
                            Ready to Train Smarter, Not Harder?
                        </h2>
                        <p className="text-sm text-indigo-100">
                            Unlock your cognitive potential with adaptive N-Back training today with a 14 day free trial.
                        </p>
                    </div>
                    
                    {/* Feature highlights in compact layout */}
                    <div className="grid grid-cols-2 gap-2 mb-4">
                        <div className="flex items-start space-x-2">
                            <div className="flex-shrink-0 h-5 w-5 flex items-center justify-center rounded-full bg-white text-indigo-700">
                                <i className="fas fa-layer-group text-xs"></i>
                            </div>
                            <div>
                                <h3 className="font-semibold text-white text-sm">Micro-Progression</h3>
                                <p className="text-indigo-200 text-xs">Smooth difficulty curve</p>
                            </div>
                        </div>
                        <div className="flex items-start space-x-2">
                            <div className="flex-shrink-0 h-5 w-5 flex items-center justify-center rounded-full bg-white text-teal-700">
                                <i className="fas fa-chart-pie text-xs"></i>
                            </div>
                            <div>
                                <h3 className="font-semibold text-white text-sm">d' Analytics</h3>
                                <p className="text-indigo-200 text-xs">Track true sensitivity</p>
                            </div>
                        </div>
                    </div>
                    
                    {/* Action button - removed secondary CTA */}
                    <div className="relative z-10">
                        <a
                            href="https://dualnback.com/signup"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="block w-full text-center px-6 py-3 bg-white text-indigo-700 text-base font-semibold rounded-lg shadow-xl hover:bg-indigo-50 focus:outline-none focus:ring-2 focus:ring-white focus:ring-opacity-50 transition transform hover:scale-105 duration-150 ease-in-out"
                        >
                            <i className="fas fa-rocket mr-2"></i> Start N-Backing
                        </a>
                    </div>
                    
                    {/* Decorative elements with pointer-events: none to prevent click interference */}
                    <div className="absolute -bottom-6 -right-6 w-24 h-24 bg-indigo-600 rounded-full opacity-20 pointer-events-none"></div>
                    <div className="absolute -top-6 -left-6 w-20 h-20 bg-indigo-400 rounded-full opacity-20 pointer-events-none"></div>
                </div>
            </div>
        </div>
    );
};

export default ReplayCallToAction;